import { DISPLAY_MODES_INSTALLED } from '../hubAlertSetup/hubAlertSetupRules';

/** Running as the installed Hub app (its own window), not a browser tab. */
export const isInstalledWindow = () =>
  DISPLAY_MODES_INSTALLED.some(mode => window.matchMedia?.(`(display-mode: ${mode})`)?.matches) ||
  (navigator as Navigator & { standalone?: boolean }).standalone === true;

/**
 * Answers the push worker's `HUB_WINDOW_MODE` question, so a tapped alert opens the installed Hub
 * app rather than a Hub tab left open in the browser (the worker cannot see display modes).
 * Registered at startup, before React, so every Hub window answers whoever is signed in.
 */
export const answerWindowModeQueries = () => {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  const container = navigator.serviceWorker;
  container.addEventListener('message', event => {
    if ((event.data as { type?: string } | null)?.type !== 'HUB_WINDOW_MODE') return;
    event.ports[0]?.postMessage({ installed: isInstalledWindow() });
  });
  // Also announce it up front (a frozen background app may not answer a question in time).
  const announce = () => {
    void container.ready
      ?.then(registration =>
        registration.active?.postMessage({
          type: 'HUB_WINDOW_MODE_IS',
          installed: isInstalledWindow(),
        }),
      )
      .catch(() => undefined);
  };
  announce();
  container.addEventListener('controllerchange', announce);
  // Chrome's "Open in app" moves a tab into the app window: the same window changes mode.
  window.matchMedia?.('(display-mode: standalone)')?.addEventListener?.('change', announce);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') announce();
  });
};
